<template>
  <div class="div-wrapper app-group-detail">

    <div class="top-div d-flex justify-content-between align-items-start  pb-3">
      <div>
        <div class="d-flex align-items-center gap-3 mb-2">
          <h5 class="mb-0" style="color: #0055A6; font-weight: bolder;">{{ appGroupData.name }}</h5>
          <Dropdown v-model="selectedAppGroupId" :options="filteredAppGroups" optionLabel="name" optionValue="id"
            :filter="false" filterBy="name" :placeholder="$t('changeAppGroup')" class="appgroup-change-dropdown" :pt="{
              panel: { class: 'my-dropdown-panel' }
            }" @change="onSelectAppGroup" @show="changeDropdownisOpen = true" @hide="changeDropdownisOpen = false">

            <template #value>
              <span class="p-dropdown-label">{{ $t('changeAppGroup') }}</span>
            </template>
            <template #dropdownicon>
              <span class="custom-arrow" :class="{ open: changeDropdownisOpen }"></span>
            </template>
            <template #header>
              <div class="custom-search">
                <input v-model="searchText" type="text" class="custom-search-input" :placeholder="$t('appGroupName')" />
                <i class="pi pi-search search-icon"></i>
              </div>
              <div class="custom-separator"></div>
            </template>

            <template #option="slotProps">
              <div class="custom-item">
                <span class="radio" :class="{ selected: slotProps.option.id === selectedAppGroupId }"></span>

                <span class="label">
                  {{ slotProps.option.name }}
                </span>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="d-flex align-items-start">
          <div class="desc-hover-container col-8">
            <template v-if="isLongDescription">
              <span class="text-muted mb-2  desc-hover-trigger" @mouseenter="showDescPanel = true"
                @mouseleave="showDescPanel = false">
                {{ truncatedDescription }}
                <div v-if="showDescPanel" class="desc-hover-panel">
                  {{ appGroupData.description }}
                </div>
              </span>
            </template>
            <span v-else class="text-muted mb-2">
              {{ appGroupData.description }}
            </span>
          </div>

          <div class="edit-btn-div">
            <button @click="showEdit($t('editAppGroup'), AppGroupForm, 'appGroup', appGroupData)"
              class="btn btn-light rounded-circle shadow-sm p-2 border ms-3 mt-1">
              <i class="ag-icon ag-icon_edit_union detail-edit-icon"></i>
            </button>
          </div>
        </div>
        <ul class="list-unstyled mt-3" style="font-size:0.8em">
          <li class="d-flex align-items-start mb-2">
            <span class=" fw-bold me-3" style="color: #0055A6; min-width: 140px; font-weight: bold;">• {{ $t("audit2")
              }}</span>
            <span>{{ getAuditNameById(appGroupData.audit) }}</span>
          </li>
          <li class="d-flex align-items-start mb-2 ">
            <span class="fw-bold me-3" style="color: #0055A6; min-width: 140px; font-weight: bold;">• {{
              $t("discoveryMode")
              }}</span>
            <span>
              <template v-if="(discoverySelectedLabels || []).length === 0">Off</template>
              <template v-else-if="(discoverySelectedLabels || []).length <= 2">
                {{ (discoverySelectedLabels || []).join(', ') }}
              </template>
              <template v-else>
                {{ (discoverySelectedLabels || []).slice(0, 2).join(', ') }}
                <a href="#" class="more-badge ms-1" style="color: #0055A6;"
                  @click.prevent="showEdit($t('editAppGroup'), AppGroupForm, 'appGroup', appGroupData)">
                  +{{ (discoverySelectedLabels || []).length - 2 }} {{ $t('more') }}
                </a>
              </template>
            </span>
          </li>
          <li class="d-flex align-items-start">
            <span class="fw-bold me-3" style="color: #0055A6; min-width: 140px; font-weight: bold;">• {{ $t("enabled")
              }}</span>
            <span>{{ appGroupData.enabled ? $t('on') : $t('off') }}</span>
          </li>
        </ul>
      </div>
      <div class="align-self-center btn-div">
        <button type="button" class="actions-btn" @click="menu.toggle($event)">
          <span class="label">{{ $t("actions2") }}</span>
          <span class="divider"></span>
          <i :class="['chevron', isMenuOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down']"></i>
        </button>
        <AppGroupImportModal ref="importModal" @imported="getList" />
        <AppGroupExportModal ref="exportModal" />
        <Menu ref="menu" :model="items" :popup="true" @show="isMenuOpen = true" @hide="isMenuOpen = false" />
      </div>
    </div>
    <TabView class="custom-tabs" v-model:activeIndex="activeTab">
      <TabPanel>
        <template #header>
          <span class="tab-header">
            <Tooltip :text="$t('tooltips.tabHeaders.processTabHeader')">
              <i class="pi pi-info-circle info-icon"></i>
            </Tooltip>
            {{ $t("process") }}
          </span>
        </template>
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit($t('addRule'), ProcessEditForm, 'process')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t("addNewRule") }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch"
              :totalRules="filteredProcessRows.length" :type="'process'" />
          </div>
          <ag-bulk-action-toolbar
            v-if="selectedIds.length > 0"
            v-model:bulk="processBulk"
            :selection-count="selectedIds.length"
            mode="process"
            @apply="onRulesBulkApply('Process')"
            @delete="onRulesBulkDelete('Process')"
            @cancelSection="clearBulkSelection"
          />
          <ag-card
            :key="tableKey"
            @return-checked-rows="onSelectionChange"
            :module="{ ...processModule, component: { ...processModule.component, options: { ...processModule.component.options, rows: filteredProcessRows } } }"
            @edit="(rowData) => editFunction2($t('editRule'), ProcessEditForm, 'process', rowData)"
            @deleteClick="(rowData) => deleteAppGroup(rowData, 'process')"
            @copyClick="(rowData) => copyFunction(rowData, 'process')">
          </ag-card>
        </div>

      </TabPanel>
      <TabPanel v-if="!isPowerApps && !isRestricted && !isAllowList && !isProhibited">
        <template #header>
          <span class="tab-header">
            <Tooltip :text="$t('tooltips.tabHeaders.fileAccessTabHeader')">
              <i class="pi pi-info-circle info-icon"></i>
            </Tooltip>
            {{ $t("fileAccess") }}
          </span>
        </template>
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit($t('addRule'), FileAccessEditForm, 'fileAccess')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t("addNewRule") }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredFileAccessRows.length" />
          </div>
          <ag-bulk-action-toolbar
            v-if="selectedIds.length > 0"
            v-model:bulk="rulesBulk"
            :selection-count="selectedIds.length"
            mode="rules"
            :disabled-delete="fileAccessDeleteDisabled"
            @apply="() => onRulesBulkApply('FileAccess')"
            @delete="() => onRulesBulkDelete('FileAccess')"
            @cancelSection="clearBulkSelection"
          />
          <ag-card
            :key="tableKey"
            @return-checked-rows="onSelectionChange"
            :module="{ ...fileAccessModule, component: { ...fileAccessModule.component, options: { ...fileAccessModule.component.options, rows: filteredFileAccessRows } } }"
            @edit="(rowData) => editFunction2($t('editRule'), FileAccessEditForm, 'fileAccess', rowData)"
            @deleteClick="(rowData) => deleteAppGroup(rowData, 'fileAccess')"
            @copyClick="(rowData) => copyFunction(rowData, 'fileAccess')">

          </ag-card>
        </div>


      </TabPanel>
      <TabPanel v-if="!isPowerApps && !isRestricted && !isAllowList && !isProhibited">
        <template #header>
          <span class="tab-header">
            <Tooltip :text="$t('tooltips.tabHeaders.registryAccessTabHeader')">
              <i class="pi pi-info-circle info-icon"></i>
            </Tooltip>
            {{ $t("registryAccess") }}
          </span>
        </template>
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit($t('addRule'), RegistryEditForm, 'registry')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t("addNewRule") }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredRegistryRows.length" />
          </div>
          <ag-bulk-action-toolbar
            v-if="selectedIds.length > 0"
            v-model:bulk="rulesBulk"
            :selection-count="selectedIds.length"
            mode="rules"
            @apply="() => onRulesBulkApply('RegistryAccess')"
            @delete="() => onRulesBulkDelete('RegistryAccess')"
            @cancelSection="clearBulkSelection"
          />
          <ag-card
            :key="tableKey"
            @return-checked-rows="onSelectionChange"
            :module="{ ...registryModule, component: { ...registryModule.component, options: { ...registryModule.component.options, rows: filteredRegistryRows } } }"
            @edit="(rowData) => editFunction2($t('editRule'), RegistryEditForm, 'registry', rowData)"
            @deleteClick="(rowData) => deleteAppGroup(rowData, 'registry')"
            @copyClick="(rowData) => copyFunction(rowData, 'registry')">

          </ag-card>
        </div>
      </TabPanel>
      <TabPanel v-if="!isRestricted && !isAllowList && !isProhibited">
        <template #header>
          <span class="tab-header">
            <Tooltip :text="$t('tooltips.tabHeaders.codeLoadTabHeader')">
              <i class="pi pi-info-circle info-icon"></i>
            </Tooltip>
            {{ $t("codeLoad") }}
          </span>
        </template>
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit($t('addRule'), CodeLoadEditForm, 'codeLoad')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t("addNewRule") }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredCodeLoadRows.length" />
          </div>
          <ag-bulk-action-toolbar
            v-if="selectedIds.length > 0"
            v-model:bulk="rulesBulk"
            :selection-count="selectedIds.length"
            mode="rules"
            @apply="() => onRulesBulkApply('CodeLoad')"
            @delete="() => onRulesBulkDelete('CodeLoad')"
            @cancelSection="clearBulkSelection"
          />
          <ag-card
            :key="tableKey"
            @return-checked-rows="onSelectionChange"
            :module="{ ...codeLoadModule, component: { ...codeLoadModule.component, options: { ...codeLoadModule.component.options, rows: filteredCodeLoadRows } } }"
            @edit="(rowData) => editFunction2($t('editRule'), CodeLoadEditForm, 'codeLoad', rowData)"
            @deleteClick="(rowData) => deleteAppGroup(rowData, 'codeLoad')"
            @copyClick="(rowData) => copyFunction(rowData, 'codeLoad')">

          </ag-card>
        </div>

      </TabPanel>
      <TabPanel v-if="!isPowerApps && !isRestricted && !isAllowList && !isProhibited">
        <template #header>
          <span class="tab-header">
            <Tooltip :text="$t('tooltips.tabHeaders.childLaunchTabHeader')">
              <i class="pi pi-info-circle info-icon"></i>
            </Tooltip>
            {{ $t("childLaunch") }}
          </span>
        </template>
        <div class="d-flex justify-content-end gap-3 mb-3">
          <Button class="custom-icon-button" @click="showEdit($t('addRule'), ChildLaunchEditForm, 'childLaunch')">
            <i class="ag-icon ag-icon_add_icon"></i>
            <span class="label-text">{{ $t("addNewRule") }}</span>
          </Button>
        </div>
        <div class="table-border-div">
          <div class="input-class align-items-center gap-2 mb-3 px-2 ">
            <TabsFilter v-model:search="searchQuery" v-model:status="statusFilter" @clear="clearSearch" :totalRules="filteredChildLaunchRows.length" />
          </div>
          <ag-bulk-action-toolbar
            v-if="selectedIds.length > 0"
            v-model:bulk="rulesBulk"
            :selection-count="selectedIds.length"
            mode="rules"
            @apply="() => onRulesBulkApply('ChildLaunch')"
            @delete="() => onRulesBulkDelete('ChildLaunch')"
            @cancelSection="clearBulkSelection"
          />
          <ag-card
            :key="tableKey"
            @return-checked-rows="onSelectionChange"
            :module="{ ...childLaunchModule, component: { ...childLaunchModule.component, options: { ...childLaunchModule.component.options, rows: filteredChildLaunchRows } } }"
            @edit="(rowData) => editFunction2($t('editRule'), ChildLaunchEditForm, 'childLaunch', rowData)"
            @deleteClick="(rowData) => deleteAppGroup(rowData, 'childLaunch')"
            @copyClick="(rowData) => copyFunction(rowData, 'childLaunch')">

          </ag-card>
        </div>

      </TabPanel>
    </TabView>

  </div>

  <EditPanel :show-enabled="true" v-model="showPanel" :title="formTitle" :form-component="formFileName"
    :form-type="formType" v-model:form="formModel" @save="saveHandler" @cancel="cancelHandler" @edit="onChildEdit"
    @back="onBack" :enum-key="formType === 'process' ? 'AppGroupProcessAccessControl' : 'AccessControl'"
    :linked-app="linkedApp" :can-go-back="canGoBack" />
  <ag-loading v-if="loading" />
</template>

<script setup>
import { ref, computed, onMounted, watch, onBeforeUnmount } from 'vue'
import ProcessTable from "@/helpers/pages/AppGroupManagement/Process";
import FileAccessTable from "@/helpers/pages/AppGroupManagement/FileAccess";
import RegistryAccessTable from "@/helpers/pages/AppGroupManagement/RegistryAccess";
import CodeLoadTable from "@/helpers/pages/AppGroupManagement/CodeLoad";
import ChildLaunchTable from "@/helpers/pages/AppGroupManagement/ChildLaunch";
import AgCard from "@/components/ag-card/index.vue";
import EditPanel from '@/components/ag-edit-panel/index.vue'
import AppGroupForm from '@/components/ag-edit-panel/forms/app-group-form.vue'
import RegistryEditForm from '@/components/ag-edit-panel/forms/registry-edit-form.vue'
import ChildLaunchEditForm from '@/components/ag-edit-panel/forms/child-launch-edit-form.vue'
import CodeLoadEditForm from '@/components/ag-edit-panel/forms/code-load-edit-form.vue'
import FileAccessEditForm from '@/components/ag-edit-panel/forms/file-access-edit-form.vue'
import ProcessEditForm from '@/components/ag-edit-panel/forms/process-edit-form.vue'
import Swal from 'sweetalert2';
import { useRoute, useRouter } from "vue-router";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import TabsFilter from '@/components/ag-tabs-filter/index.vue'
import routerPage from '@/router/index'
import AgLoading from "@/components/ag-loading/index.vue";
import { AppGroupTypes } from "@/helpers/enums/AppGroupTypes";
import AppGroupImportModal from "@/components/ag-edit-panel/forms/app-group-import-modal.vue";
import Tooltip from '@/components/ag-edit-panel/forms/components/tooltip.vue';
import { useI18n } from 'vue-i18n';
import AppGroupExportModal from '@/components/ag-edit-panel/forms/app-group-export-modal.vue';
import Dropdown from 'primevue/dropdown'
import AgBulkActionToolbar from '@/components/ag-bulk-action-toolbar/index.vue'
const { t } = useI18n();
const loading = ref(false);
const store = useStore();
let processModule = ref(ProcessTable)
let fileAccessModule = ref(FileAccessTable)
let registryModule = ref(RegistryAccessTable)
let codeLoadModule = ref(CodeLoadTable)
let childLaunchModule = ref(ChildLaunchTable)
let formTitle = ref(t('editAppGroup'))
let formFileName = ref(AppGroupForm)
const searchQuery = ref('');
const statusFilter = ref([]);
const showPanel = ref(false)
const appGroupData = ref({})
const route = useRoute();
const router = useRouter();
const appGroupId = computed(() => route.query.id);
const formModel = ref({})
const formType = ref('appGroup');
const tableRowData = ref({})
const activeTab = ref(0);
const companyId = ref('')
const childLaunchList = computed(() => store.state.general.appGroupsChildLaunch);
const registryList = computed(() => store.state.general.appGroupsRegistryAccess);
const fileAccessList = computed(() => store.state.general.appGroupsFileAccess);
const codeLoadList = computed(() => store.state.general.appGroupsCodeLoad);
const processList = computed(() => store.state.general.appGroupsProcess);
const appGroupInfo = computed(() => store.state.general.appGroupInfo)
const linkedApp = ref(false);
const canGoBack = ref(false);
const isPowerApps = computed(() => Number(appGroupInfo.value?.appGroupType) === AppGroupTypes.PowerApps)
const isRestricted = computed(() => Number(appGroupInfo.value?.appGroupType) === AppGroupTypes.Restricted)
const isAllowList = computed(() => Number(appGroupInfo.value?.appGroupType) === AppGroupTypes.AllowList)
const isProhibited = computed(() => Number(appGroupInfo.value?.appGroupType) === AppGroupTypes.Prohibited)
const backTitle = ref(t('editRule'));
const templatePolicy = ref(false);
const group = ref(null);
const site = ref({});
const template =ref('');
const templateId = ref(0);
const currentRole = ref('');
const didOpenFromQuery = ref(false);
const exportModal = ref(null);
const searchText = ref('');
const selectedIds = ref([]);
const fileAccessDeleteDisabled = computed(() =>
  selectedIds.value.some(id => {
    const row = (fileAccessModule.value.component.options.rows || []).find(r => r.id == id);
    return row && row.processId !== null;
  })
);
const rulesBulk = ref({ enabled: null, processDiscoveryMode: null });
const processBulk = ref({ enabled: null, processDiscovery: null });
const tableKey = ref(0);

function onSelectionChange(ids) {
  selectedIds.value = Array.isArray(ids) ? ids : [];
  
  if (selectedIds.value.length === 0) {
    rulesBulk.value = { enabled: null, processDiscoveryMode: null };
    processBulk.value = { enabled: null, processDiscovery: null };
  }
}
const appGroupRuleType = computed(() => store.state.general.enums['appGroupRuleType'] || []);
async function onRulesBulkApply(type) {
  const ruleType = appGroupRuleType.value.find(r => r.label === type);
  const payload = {
    appGroupId: appGroupId.value,
    appGroupRuleType: ruleType?.value,
    ruleIds: selectedIds.value,
    delete: false
  }
  if (String(type).toLowerCase() === 'process') {
    if(processBulk.value.processDiscovery !== null){
      payload.discoveryMode = processBulk.value.processDiscovery;
    }
    if(processBulk.value.enabled !== null){
      payload.enabled = processBulk.value.enabled;
    }
  }else{
    if(rulesBulk.value.enabled !== null){
      payload.enabled = rulesBulk.value.enabled;
    }
  }
  
  const typeLC = String(type).toLowerCase();
  if (typeLC === 'process') {
    processModule.value.component.options.isLoading = true;
  } else if (typeLC === 'fileaccess') {
    fileAccessModule.value.component.options.isLoading = true;
  } else if (typeLC === 'registryaccess') {
    registryModule.value.component.options.isLoading = true;
  } else if (typeLC === 'codeload') {
    codeLoadModule.value.component.options.isLoading = true;
  } else if (typeLC === 'childlaunch') {
    childLaunchModule.value.component.options.isLoading = true;
  }
  
  await store.dispatch(GeneralActionTypes.BULK_ACTION_APPGROUP_DETAIL_RULES, payload).then(async (response) => {
    if(response.isSuccess){
      const successCount = response.entityData.successCount;
      const failedCount = response.entityData.failedCount;
      let successText = `${successCount} ${t('ruleBulkApplySuccess')}`;
      let failedText = '';
      if(failedCount > 0) {
        failedText = ` ${failedCount} ${t('ruleBulkApplyFailed')}`;
      }
      Swal.fire({ title: 'Success', text: successText + failedText, icon: 'success' });
      
      await getInheritanceInfo();
    }else{
      Swal.fire({ title: 'Error', text: response.entityData.message , icon: 'error' });
    }
    
    if (typeLC === 'process') {
      processModule.value.component.options.isLoading = false;
    } else if (typeLC === 'fileaccess') {
      fileAccessModule.value.component.options.isLoading = false;
    } else if (typeLC === 'registryaccess') {
      registryModule.value.component.options.isLoading = false;
    } else if (typeLC === 'codeload') {
      codeLoadModule.value.component.options.isLoading = false;
    } else if (typeLC === 'childlaunch') {
      childLaunchModule.value.component.options.isLoading = false;
    }
    
    selectedIds.value = [];
    tableKey.value++;
    fetchForTab(activeTab.value);
    resetBulkSelections();
  })
}
async function onRulesBulkDelete(type) {
  const ruleType = appGroupRuleType.value.find(r => r.label === type);
  const payload = {
    appGroupId: appGroupId.value,
    appGroupRuleType: ruleType?.value,
    ruleIds: selectedIds.value,
    enabled: rulesBulk.value.enabled,
    delete: true
  }

  if (String(type).toLowerCase() === 'process') {
    payload.discoveryMode = rulesBulk.value.processDiscoveryMode;
  }

  const typeLC = String(type).toLowerCase();
  if (typeLC === 'process') {
    processModule.value.component.options.isLoading = true;
  } else if (typeLC === 'fileaccess') {
    fileAccessModule.value.component.options.isLoading = true;
  } else if (typeLC === 'registryaccess') {
    registryModule.value.component.options.isLoading = true;
  } else if (typeLC === 'codeload') {
    codeLoadModule.value.component.options.isLoading = true;
  } else if (typeLC === 'childlaunch') {
    childLaunchModule.value.component.options.isLoading = true;
  }

  try {
    const response = await store.dispatch(GeneralActionTypes.BULK_ACTION_APPGROUP_DETAIL_RULES, payload);
    if (response.isSuccess) {
      const successCount = response.entityData.successCount;
      const failedCount = response.entityData.failedCount;
      let successText = `${successCount} ${t('ruleBulkDeleteSuccess')}`;
      let htmlText = `${successText}`;
      let failedText = '';
      if(failedCount > 0) {
        failedText = ` ${failedCount} ${t('ruleBulkDeleteFailed')}`;
        htmlText = `${successText}<br>${failedText}`;
      }

      await Swal.fire({ title: 'Success', html: htmlText, icon: 'success' });
      await getInheritanceInfo();
    } else {
      const serverData = response?.entityData ?? response ?? {};
      const msg = serverData?.message || (serverData?.errors && extractErrorMessage(serverData.errors)) || t('rulesBulkDeleteFailed');
      await Swal.fire({ title: 'Error', html: msg, icon: 'error' });
    }
  } catch (error) {
    await Swal.fire({ title: 'Error', html: error, icon: 'error' });
  } finally {
    if (typeLC === 'process') {
      processModule.value.component.options.isLoading = false;
    } else if (typeLC === 'fileaccess') {
      fileAccessModule.value.component.options.isLoading = false;
    } else if (typeLC === 'registryaccess') {
      registryModule.value.component.options.isLoading = false;
    } else if (typeLC === 'codeload') {
      codeLoadModule.value.component.options.isLoading = false;
    } else if (typeLC === 'childlaunch') {
      childLaunchModule.value.component.options.isLoading = false;
    }
    
    selectedIds.value = [];
    tableKey.value++;
    fetchForTab(activeTab.value);
    //resetBulkSelections();
  }
}
function resetBulkSelections() {
  rulesBulk.value = {
    enabled: null,
    processDiscoveryMode: null,
  };
  processBulk.value = { enabled: null, processDiscovery: null };
}

function clearBulkSelection() {
  selectedIds.value = [];
  
  [processList, fileAccessList, registryList, codeLoadList, childLaunchList].forEach(list => {
    if (list.value && Array.isArray(list.value)) {
      list.value.forEach(row => {
        if (row) row.checked = false;
      });
    }
  });
  
  tableKey.value++;
  resetBulkSelections();
}

const filteredAppGroups = computed(() => {
  return appGroups.value.filter(item =>
    item.name.toLowerCase().includes(searchText.value.toLowerCase())
  )
})
const changeDropdownisOpen = ref(false);
const showResetToDefaults = computed(() => {
  if(templatePolicy.value && appGroupData.value.appGroupType === AppGroupTypes.Custom) return false;
  if ( appGroupData.value.appGroupType === AppGroupTypes.Custom && store.state.general.inheritanceInfo?.templatePolicyId === null) return false;
  return true;
});
function getAuditNameById(value) {
  const auditOptions = computed(() => store.state.general.enums['AppGroupAudit'] || [])
  const audit = auditOptions.value.find((item) => item.value === value);
  return audit?.label;
}

watch(activeTab, (newIndex) => {
  searchQuery.value = '';
  statusFilter.value = [];
  selectedIds.value = [];
  tableKey.value++;
  fetchForTab(newIndex);
  if(newIndex !== 0) {
    const newQuery = { ...(route.query || {}) };
    delete newQuery.tab;
    if (didOpenFromQuery.value) delete newQuery.ruleId;
    router.replace({ query: newQuery });
  }
  if(newIndex !== 1){
    const newQuery = { ...(route.query || {}) };
    delete newQuery.tab;
    if (didOpenFromQuery.value) delete newQuery.ruleGuid;
    router.replace({ query: newQuery });
  }
});

function fetchForTab(index) {
  switch (index) {
    case 0:
      if (processModule.value?.component?.options) {
        processModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getProcessListTemplate();
      } else {
        getProcessList();
      }
      break;
    case 1:
      if (isPowerApps.value) {
        if (codeLoadModule.value?.component?.options) {
          codeLoadModule.value.component.options.isLoading = true;
        }
        if (templatePolicy.value) {
          getCodeLoadListTemplate();
        } else {
          getCodeLoadList();
        }
      } else {
        if (fileAccessModule.value?.component?.options) {
          fileAccessModule.value.component.options.isLoading = true;
        }
        if (templatePolicy.value) {
          getFileAccessListTemplate();
        } else {
          getFileAccessList();
        }
      }
      break;
    case 2:
      if (registryModule.value?.component?.options) {
        registryModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getRegistryListTemplate();
      } else {
        getRegistryList();
      }
      break;
    case 3:
      if (codeLoadModule.value?.component?.options) {
        codeLoadModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getCodeLoadListTemplate();
      } else {
        getCodeLoadList();
      }
      break;
    case 4:
      if (childLaunchModule.value?.component?.options) {
        childLaunchModule.value.component.options.isLoading = true;
      }
      if (templatePolicy.value) {
        getChildLaunchListTemplate();
      } else {
        getChildLaunchList();
      }
      break;
  }
}

function setTabFromQuery() {
  const tab = route.query?.tab;

  if (!tab) return;
  
  switch (tab) {
    case 'process':
      activeTab.value = 0;
      break;
    case 'fileAccess':
      activeTab.value = isPowerApps.value ? 0 : 1;
      break;
    case 'registry':
      activeTab.value = isPowerApps.value ? 1 : 2;
      break;
    case 'codeLoad':
      activeTab.value = isPowerApps.value ? 1 : 3;
      break;
    case 'childLaunch':
      activeTab.value = isPowerApps.value ? 2 : 4;
      break;
  }
}

watch(() => route.query.id, () => {
  resetAllTables();
  selectedIds.value = [];
  activeTab.value = 0;
  tableKey.value++;
  templatePolicy.value ? getAppGroupDetailTemplate(appGroupId) : getAppGroupDetail(appGroupId);
  fetchForTab(activeTab.value);
});

watch(() => route.query.tab, () => {
  setTabFromQuery();
}, { immediate: true });


const useFilteredRows = (rows, searchQuery, statusFilter, getFields, getDiscovery) => {
  const query = searchQuery.value.toLowerCase();
  const statusList = statusFilter.value;

  return rows.filter(row => {
    const searchableFields = getFields(row).map(f =>
      (f || "").toLowerCase()
    );

    const matchesSearch =
      !query || searchableFields.some(field => field.includes(query));
    const statusSubset = Array.isArray(statusList)
      ? statusList.filter(v => v === 'enabled' || v === 'disabled')
      : [];
    const discoverySubset = Array.isArray(statusList)
      ? statusList.filter(v => v === 'discoveryOn' || v === 'discoveryOff')
      : [];

    const matchesStatus =
      statusSubset.length === 0 ||
      (statusSubset.includes('enabled') && row.enabled === true) ||
      (statusSubset.includes('disabled') && row.enabled === false);

    let matchesDiscovery = true;
    if (typeof getDiscovery === 'function' && discoverySubset.length > 0) {
      const val = !!getDiscovery(row);
      matchesDiscovery =
        (discoverySubset.includes('discoveryOn') && val === true) ||
        (discoverySubset.includes('discoveryOff') && val === false);
    }

    return matchesSearch && matchesStatus && matchesDiscovery;
  });
};
const filteredFileAccessRows = computed(() =>
  useFilteredRows(
    fileAccessModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => [
      row.folderMapId ? getFolderNameById(row.folderMapId) : "",
      row.fileName ? row.fileName : "",
      row.accessControl ? getAccessControlById(row.accessControl) : ""
    ]
  )
);
const filteredRegistryRows = computed(() =>
  useFilteredRows(
    registryModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => [
      row.registryKey ? row.registryKey : "",
      row.registryValue ? row.registryValue : "",
      row.registryHive ? getRegistryHiveById(row.registryHive) : "",
      row.accessControl ? getAccessControlById(row.accessControl) : "",
      row.appliesTo ? getAppliesToById(row.appliesTo) : ""
    ]
  )
);

const filteredCodeLoadRows = computed(() =>
  useFilteredRows(
    codeLoadModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => {
      const folderMapName = row.folderMapId ? getFolderNameById(row.folderMapId) : "";
      const fileName = row.fileName ? row.fileName : "";
      const securityAction = row.allowToRun ? "Allow to run" : "Allow to run off";
      return [folderMapName, fileName, securityAction];
    }
  )
);
const filteredChildLaunchRows = computed(() =>
  useFilteredRows(
    childLaunchModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => {
      const folderMapName = row.folderMapId ? getFolderNameById(row.folderMapId) : "";
      const fileName = row.fileName ? row.fileName : "";
      const securityAction = [];
      if (row.allowLaunch) securityAction.push("Allow Launch");
      if (row.neverInheritFromParent) securityAction.push("Never Inherit From Parent");
      return [folderMapName, fileName, securityAction.join(" ")];
    }
  )
);

const filteredProcessRows = computed(() =>
  useFilteredRows(
    processModule.value.component.options.rows,
    searchQuery,
    statusFilter,
    row => {
      const folderMapName = row.folderMapId ? getFolderNameById(row.folderMapId) : "";
      const fileName = row.fileName;
      const displayName = row.displayName;
      const accessControl = row.accessControl ? getProcessAccessControlById(row.accessControl) : "";
      const additionalControl = [];
      if (row.applicationExecutionControl) additionalControl.push("Executable Control");
      if (row.moduleControl) additionalControl.push("Script & Module Control");
      return [folderMapName, fileName, displayName, accessControl, additionalControl.join(" ")];
    },
    (row) => row?.discoveryMode === true
  )
);

function getFolderNameById(value) {
  if (value === undefined || value === null) {
    return;
  }
  const folderMaps = store.state.general.folderMaps;
  const folder = folderMaps.find(item => item.value === value);
  return folder ? folder.label : undefined;
}
function getAccessControlById(value) {
  const accessControlOptions = store.state.general.enums['AccessControl'] || []
  const folder = accessControlOptions.find((item) => item.value === value);
  return folder?.label;
}
function getProcessAccessControlById(value) {
  const accessControlOptions = store.state.general.enums['AppGroupProcessAccessControl'] || []
  const folder = accessControlOptions.find((item) => item.value === value);
  return folder?.label;
}
function getAppliesToById(value) {
  const appliesToOptions = store.state.general.enums['AppliesTo'] || []
  const option = appliesToOptions.find((item) => item.value === value);
  return option?.label;
}
function getRegistryHiveById(value) {
  const registryHiveOptions = store.state.general.enums['RegistryHive'] || []
  const option = registryHiveOptions.find((item) => item.value === value);
  return option?.label;
}

const extractErrorMessage = (errors) => {
  if (!errors) return null;
  if (typeof errors === "string") return errors;
  if (Array.isArray(errors)) return errors.flat().join("<br>");
  if (typeof errors === "object") return Object.values(errors).flat().join("<br>");
  return String(errors);
};

function showError(err) {
  const serverData = err?.response?.data ?? err?.data ?? null;
  let msg = "";

  if (serverData?.errors) {
    msg = extractErrorMessage(serverData.errors);
  } else if (serverData?.title) {
    msg = serverData.title;
  } else if (err?.message) {
    msg = err.message;
  } else {
    msg = JSON.stringify(err);
  }

  Swal.fire({
    title: "Error",
    html: msg || "Unexpected error",
    icon: "error"
  });
}
const successMessage = (id) => {
  if (id === 0) {
    Swal.fire("Success!", t('ruleAddedSuccessfully'), "success");
  } else {
    Swal.fire("Success!", t('ruleUpdatedSuccessfully'), "success");
  }
}

const clearRuleIdFromRoute = () => {
  const newQuery = { ...(route.query || {}) };
  if ('ruleId' in newQuery) {
    delete newQuery.ruleId;
    router.replace({ query: newQuery });
  }
  else if ('ruleGuid' in newQuery) {
    delete newQuery.ruleGuid;
    router.replace({ query: newQuery });
  }
};

const saveHandler = async (updatedData) => {
  const group = localStorage.getItem("agms_group");
  const groupId = group ? JSON.parse(group)?.mainid : null;

  if (formType.value === "appGroup") {
    loading.value = true;
    appGroupData.value = { ...formModel.value }
    let body = {
      id: updatedData.id,
      name: updatedData.name,
      description: updatedData.description,
      memorySecurity: updatedData.memorySecurity,
      inheritance: updatedData.inheritance,
      subsystemsInDiscoveryMode: updatedData.subsystemsInDiscoveryMode,
      audit: updatedData.audit,
      companyId: companyId.value ? companyId.value : null,
      groupId: groupId,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      appGroupType: updatedData.appGroupType,
      expertNotes: updatedData.expertNotes,
      childProcess: updatedData.childProcess,
      templateId: templateId.value ? templateId.value : null,
    }
    try {
      const response = templatePolicy.value ? await store.dispatch(
        GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_TEMPLATE,
        body
      ) : await store.dispatch(
        GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP,
        body
      );
      if (response.isSuccess) {
        showPanel.value = false;
        loading.value = false;
        templatePolicy.value ? getAppGroupDetailTemplate(appGroupId) : getAppGroupDetail(appGroupId);
        getInheritanceInfo();
        Swal.fire("Success!", t('appGroupUpdatedSuccessfully'), "success");

      }
    } catch (err) {
      loading.value = false;
      showError(err);
    }
  }
  else if (formType.value === "childLaunch") {
    childLaunchModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      appGroupId: formModel.value.appGroupId ? formModel.value.appGroupId : appGroupData.value.id,
      folderMapId: updatedData.isFolderMapIdAny ? -1 : updatedData.folderMapId,
      fileName: updatedData.fileName,
      allowLaunch: updatedData.allowLaunch ? updatedData.allowLaunch : false,
      neverInheritFromParent: updatedData.neverInheritFromParent ? updatedData.neverInheritFromParent : false,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      expertNotes: updatedData.expertNotes,
      templateId: templateId.value ? templateId.value : null,
    }

    try {
      let response = null;
      if(templatePolicy.value) {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH_TEMPLATE,
          body
        );
      }else {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        if (templatePolicy.value) {
          getChildLaunchListTemplate();
          getAppGroupDetailTemplate(appGroupId);
        } else {
          getChildLaunchList();
          getInheritanceInfo();
          getAppGroupDetail(appGroupId);
        }
        successMessage(body.id);
      }
    } catch (err) {
      childLaunchModule.value.component.options.isLoading = false;
      showError(err);
    }

  } else if (formType.value === 'registry') {
    registryModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      appGroupId: formModel.value.appGroupId ? formModel.value.appGroupId : appGroupData.value.id,
      registryHive: updatedData.registryHive,
      registryKey: updatedData.registryKey ? updatedData.registryKey : "",
      registryValue: updatedData.registryValue ? updatedData.registryValue : "",
      accessControl: updatedData.accessControl,
      appliesTo: updatedData.appliesTo,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      expertNotes: updatedData.expertNotes,
      templateId: templateId.value ? templateId.value : null,
    }
    try {
      let response = null;
      if(templatePolicy.value) {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_REGISTRY_TEMPLATE,
          body
        );
      }else {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_REGISTRY,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        if (templatePolicy.value) {
          getRegistryListTemplate();
          getAppGroupDetailTemplate(appGroupId);
        } else {
          getRegistryList();
          getInheritanceInfo();
          getAppGroupDetail(appGroupId);
        }
        successMessage(body.id);
      }
    } catch (err) {
      registryModule.value.component.options.isLoading = false;
      showError(err);
    }

  }
  else if (formType.value === 'fileAccess') {
    fileAccessModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      appGroupId: formModel.value.appGroupId ? formModel.value.appGroupId : appGroupData.value.id,
      folderMapId: updatedData.isFolderMapIdAny ? -1 : updatedData.folderMapId,
      fileName: updatedData.fileName,
      accessControl: updatedData.accessControl,
      auditCreateOperations: updatedData.auditCreateOperations,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      expertNotes: updatedData.expertNotes,
      templateId: templateId.value ? templateId.value : null,
      processId: formModel.value.processId ? formModel.value.processId : null,
      selectedAppGroupType: appGroupData.value.appGroupType
    }
    try {
      let response = null;
      if(templatePolicy.value) {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS_TEMPLATE,
          body
        );
      }else {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        if (templatePolicy.value) {
          getFileAccessListTemplate();
          getAppGroupDetailTemplate(appGroupId);
        } else {
          getFileAccessList();
          getInheritanceInfo();
          getAppGroupDetail(appGroupId);
        }
        successMessage(body.id !== 0 ? body.id : body.processId ? body.processId : 0);
      }
    } catch (err) {
      fileAccessModule.value.component.options.isLoading = false;
      showError(err);
    }

  }
  else if (formType.value === 'codeLoad') {
    codeLoadModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      appGroupId: formModel.value.appGroupId ? formModel.value.appGroupId : appGroupData.value.id,
      folderMapId: updatedData.isFolderMapIdAny ? -1 : updatedData.folderMapId,
      fileName: updatedData.fileName,
      zoneIdentifier: updatedData.zoneIdentifier ? updatedData.zoneIdentifier : 0,
      allowToRun: updatedData.allowToRun,
      // bAppyToPowerApps: updatedData.bAppyToPowerApps? updatedData.bAppyToPowerApps : false,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      publisherId: updatedData.isPublisherIdAny ? -1 : updatedData.publisherId,
      expertNotes: updatedData.expertNotes,
      templateId: templateId.value ? templateId.value : null,
    }
    try {
      let response = null;
      if(templatePolicy.value) {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CODE_LOAD_TEMPLATE,
          body
        );
      }else {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CODE_LOAD,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        if (templatePolicy.value) {
          getCodeLoadListTemplate();
          getAppGroupDetailTemplate(appGroupId);
        } else {
          getCodeLoadList();
          getInheritanceInfo();
          getAppGroupDetail(appGroupId);
        }
        successMessage(body.id);
      }
    } catch (err) {
      codeLoadModule.value.component.options.isLoading = false;
      showError(err);
    }

  }
  else if (formType.value === 'process') {
    processModule.value.component.options.isLoading = true;
    let body = {
      id: formModel.value.id ? formModel.value.id : 0,
      appGroupId: formModel.value.appGroupId ? formModel.value.appGroupId : appGroupData.value.id,
      folderMapId: updatedData.isFolderMapIdAny ? -1 : updatedData.folderMapId,
      fileName: updatedData.fileName,
      accessControl: updatedData.accessControl,
      enabled: updatedData.enabled ? updatedData.enabled : false,
      discoveryMode: updatedData.discoveryMode ? updatedData.discoveryMode : false,
      applicationExecutionControl: updatedData.applicationExecutionControl ? updatedData.applicationExecutionControl : false,
      aecConditionHashAlgorithm: updatedData.aecConditionHashAlgorithm,
      aecConditionHash: updatedData.aecConditionHashAlgorithm === null || updatedData.aecConditionHashAlgorithm === undefined ? null : updatedData.aecConditionHash,
      aecConditionCommandLine: updatedData.aecConditionCommandLine,
      aecConditionZoneIdentifier: updatedData.aecConditionZoneIdentifier ? updatedData.aecConditionZoneIdentifier : 0,
      aecSecurityAllowRun: updatedData.aecSecurityAllowRun ? updatedData.aecSecurityAllowRun : false,
      aecSecuritySeamlessInstaller: updatedData.aecSecuritySeamlessInstaller ? updatedData.aecSecuritySeamlessInstaller : false,
      aecSecurityChildProcess: updatedData.aecSecurityChildProcess ?? 0,
      aecSecurityMemory: updatedData.aecSecurityMemory,
      aecSecurityInheritance: updatedData.aecSecurityInheritance,
      moduleConditionZoneIdentifier: updatedData.moduleConditionZoneIdentifier ? updatedData.moduleConditionZoneIdentifier : 0,
      moduleControl: updatedData.moduleControl ? updatedData.moduleControl : false,
      moduleConditionHashAlgorithm: updatedData.moduleConditionHashAlgorithm,
      moduleConditionHash: updatedData.moduleConditionHashAlgorithm === null || updatedData.moduleConditionHashAlgorithm === undefined ? null : updatedData.moduleConditionHash,
      moduleSecurityAllowRun: updatedData.moduleSecurityAllowRun ? updatedData.moduleSecurityAllowRun : false,
      moduleSecuritySeamlessInstaller: updatedData.moduleSecuritySeamlessInstaller ? updatedData.moduleSecuritySeamlessInstaller : false,
      moduleSecurityChildProcess: updatedData.moduleSecurityChildProcess ?? 0,
      moduleSecurityMemory: updatedData.moduleSecurityMemory,
      // bChildProcessExceptions: updatedData.bChildProcessExceptions,
      aecPublisherId: updatedData.isAecPublisherIdAny ? -1 : updatedData.aecPublisherId,
      modulePublisherId: updatedData.isModulePublisherIdAny ? -1 : updatedData.modulePublisherId,
      aecCodeLoadSecurity: updatedData.aecCodeLoadSecurity ?? 0,
      expertNotes: updatedData.expertNotes,
      templateId: templateId.value ? templateId.value : null,
      appGroupProcessHashes: updatedData.appGroupProcessHashes,
    }
    try {
      let response = null;
      if(templatePolicy.value) {
        body.aecSecurityContainment = appGroupData.value.name;
        body.moduleSecurityContainment = appGroupData.value.name;
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_PROCESS_TEMPLATE,
          body
        );
      }else {
        response = await store.dispatch(
          GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_PROCESS,
          body
        );
      }
      if (response.isSuccess) {
        showPanel.value = false;
        clearRuleIdFromRoute();
        if (templatePolicy.value) {
          getProcessListTemplate();
          getAppGroupDetailTemplate(appGroupId);
        } else {
          getProcessList();
          getInheritanceInfo();
          getAppGroupDetail(appGroupId);
        }
        successMessage(body.id);
      }
    } catch (err) {
      processModule.value.component.options.isLoading = false;
      showError(err);
    }

  }
  else if (formType.value === 'fileTypePolicy') {
    const group = localStorage.getItem("agms_group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
    const body = {
      id: updatedData.id ? updatedData.id : 0,
      name: updatedData.name,
      fileExtensionDaos: updatedData.fileExtensionDaos,
      fileExtensionApps: updatedData.fileExtensionApps,
      groupId: groupId,
      ruleGuid: updatedData.ruleGuid ? updatedData.ruleGuid : null,
      enabled: updatedData.enabled,
      expertNotes: updatedData.expertNotes,
      templateId: templateId.value ? templateId.value : null,
    };
    try {
      const response = templatePolicy.value ? await store.dispatch(
        GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY_TEMPLATE,
        body
      ) : await store.dispatch(
        GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY,
        body
      );
      if (response.isSuccess) {
        if (templatePolicy.value) {
          getProcessListTemplate();
        } else {
          getProcessList();
          getInheritanceInfo();
        }
        Swal.fire("Success!", "File Type Policy saved successfully.", "success");
        if (canGoBack.value) {
          onBack();
        } else {
          showPanel.value = false;
        }
      }
    } catch (err) {
      showError(err);
    }
  }
}

function cancelHandler() {
  clearRuleIdFromRoute();
}
const getAppGroupDetail = async (groupId) => {
  try {
    const response = await store.dispatch(GeneralActionTypes.GET_APPGROUP_DETAIL, groupId.value);
    if (response.isSuccess) {
      appGroupData.value = response.entityData;
    }

  } catch (error) {
    console.error("AppGroup detail fetch error:", error);
  }
};
const getAppGroupDetailTemplate = async (appGroupId) => {
  try {
    const response = await store.dispatch(GeneralActionTypes.GET_APPGROUP_DETAIL_TEMPLATE, appGroupId.value);
    if (response.isSuccess) {
      appGroupData.value = response.entityData.templatePolicyViewModel.appGroup;
    }

  } catch (error) {
    console.error("AppGroup detail fetch error:", error);
  }
};
const getFolderMaps = async () => {
  await store.dispatch(GeneralActionTypes.GET_FOLDER_MAPS);
}
const getChildLaunchList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH, appGroupInfo.value.id);
  } finally {
    childLaunchModule.value.component.options.isLoading = false;
  }
};
const getChildLaunchListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH_TEMPLATE, appGroupId.value);
  } finally {
    childLaunchModule.value.component.options.isLoading = false;
  }
};
const getRegistryList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_REGISTRY, appGroupInfo.value.id)
  } finally {
    registryModule.value.component.options.isLoading = false;
  }
}
const getRegistryListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_REGISTRY_TEMPLATE, appGroupId.value)
  } finally {
    registryModule.value.component.options.isLoading = false;
  }
}
const getFileAccessList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_FILE_ACCESS, appGroupInfo.value.id)
  } finally {
    fileAccessModule.value.component.options.isLoading = false;
  }
}
const getFileAccessListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_FILE_ACCESS_TEMPLATE, appGroupId.value)
  } finally {
    fileAccessModule.value.component.options.isLoading = false;
  }
}
const getCodeLoadList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_CODE_LOAD, appGroupInfo.value.id)
  } finally {
    codeLoadModule.value.component.options.isLoading = false;
  }
}
const getCodeLoadListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_CODE_LOAD_TEMPLATE, appGroupId.value)
  } finally {
    codeLoadModule.value.component.options.isLoading = false;
  }
}
const getProcessList = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_PROCESS, appGroupInfo.value.id)
  } finally {
    processModule.value.component.options.isLoading = false;
  }
}
const getProcessListTemplate = async () => {
  try {
    await store.dispatch(GeneralActionTypes.GET_APPGROUP_PROCESS_TEMPLATE, appGroupId.value)
  } finally {
    processModule.value.component.options.isLoading = false;
  }
}
const getFileTypePolicyList = async () => {
  templatePolicy.value ? await store.dispatch(GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES_TEMPLATE) : await store.dispatch(GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES)
}
watch(appGroupInfo, (newVal) => {
  if (newVal?.id) {
    fetchForTab(activeTab.value);
  }
});
watch(childLaunchList, () => {
  if (childLaunchModule.value?.component?.options) {
    childLaunchModule.value.component.options.rows = childLaunchList.value;
  }
  if (activeTab.value === 4) {
    openEditModalFromQuery (4);
  }
});
watch(registryList, () => {
  if (registryModule.value?.component?.options) {
    registryModule.value.component.options.rows = registryList.value;
  }
  if (activeTab.value === 2) {
    openEditModalFromQuery (2);
  }
});
watch(fileAccessList, () => {
  if (fileAccessModule.value?.component?.options) {
    fileAccessModule.value.component.options.rows = fileAccessList.value;
  }
  if (activeTab.value === 1) {
    openEditModalFromQuery (1);
  }
});
watch(codeLoadList, () => {
  if (codeLoadModule.value?.component?.options) {
    codeLoadModule.value.component.options.rows = codeLoadList.value;
  }
  if (activeTab.value === 3) {
    openEditModalFromQuery (3);
  }
});
watch(processList, () => {
  if (processModule.value?.component?.options) {
    processModule.value.component.options.rows = processList.value;
  }
  if (activeTab.value === 0) {
    openEditModalFromQuery (0);
  }
});

const getPublisherList = async () => {
  const group = JSON.parse(localStorage.getItem("group"))
  const mainId = group ? group.mainid : 0;
  await store.dispatch(GeneralActionTypes.GET_PUBLISHER_LIST, mainId);
}
const getPublisherListTemplate = async () => {
  await store.dispatch(GeneralActionTypes.GET_TEMPLATE_PUBLISHER_LIST, templateId.value);
}
const fetchEnumAndStore = async (name) => {
  await store.dispatch(GeneralActionTypes.GET_ENUM_BY_NAME, name);
};

const getListTemplate = async (templateId) => {
  await store.dispatch(GeneralActionTypes.GET_APPGROUPS_TEMPLATE, templateId);
};

const getInheritanceInfo = async () => {
  await store.dispatch(GeneralActionTypes.GET_APPGROUP_INHERITANCE_INFO, { appGroupId: appGroupId.value });
};

const appGroups = computed(() => store.state.general.appGroups || []);
const selectedAppGroupId = ref(null);

onMounted(() => {
  try {
    store.dispatch(GeneralActionTypes.LOADER_STATUS, false);
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('paddingRight');
  } catch (e) { console.error(e); }
  const routeName = useRoute().name;
  if (routeName == 'templateAppGroupDetail') {
    templatePolicy.value = true;
    const templateStr = localStorage.getItem("agms_template");
    const mainId = templateStr ? JSON.parse(templateStr)?.mainid : null;
    currentRole.value = templateStr ? JSON.parse(templateStr)?.template : null;
    templateId.value = mainId;
    getPublisherListTemplate();
  } else {
    templatePolicy.value = false;
    getPublisherList();
    getInheritanceInfo();
  }
  group.value = JSON.parse(localStorage.getItem("agms_group")) || {};
  site.value = JSON.parse(localStorage.getItem("agms_site")) || {};
  const company = JSON.parse(localStorage.getItem('company'));
  if (company) {
    companyId.value = company.companyGuid;
  }
  openEditModalFromQuery (activeTab.value);
  templatePolicy.value ? getAppGroupDetailTemplate(appGroupId) : getAppGroupDetail(appGroupId);
  getFolderMaps();

  fetchEnumAndStore('AccessControl');
  fetchEnumAndStore('AppGroupProcessAccessControl');
  fetchEnumAndStore("RegistryHive");
  fetchEnumAndStore("AppliesTo");
  fetchEnumAndStore("ZoneIdentifier");
  fetchEnumAndStore("ChildProcessTypes");
  fetchEnumAndStore("HashAlgorithmTypes");
  fetchEnumAndStore("AecSecurityInheritance ");
  fetchEnumAndStore("DiscoveryMode");
  fetchEnumAndStore("MemorySecurity");
  fetchEnumAndStore("AppGroupProcessMemorySecurity");
  fetchEnumAndStore("Inheritance");
  fetchEnumAndStore("AppGroupAudit");
  fetchEnumAndStore("CodeLoadSecurity");
  fetchEnumAndStore("appGroupRuleType");
  getFileTypePolicyList();

  if (!store.state.general.appGroups || store.state.general.appGroups.length === 0) {
    if (templatePolicy.value) {
      store.dispatch(GeneralActionTypes.GET_APPGROUPS_TEMPLATE, templateId.value);
    } else {
      store.dispatch(GeneralActionTypes.GET_APPGROUPS, {});
    }
  }

  selectedAppGroupId.value = appGroupId.value ? Number(appGroupId.value) : null;

});

function resetAllTables() {
  const modules = [processModule, fileAccessModule, registryModule, codeLoadModule, childLaunchModule];
  modules.forEach((m) => {
    const opts = m?.value?.component?.options;
    if (opts) {
      opts.rows = [];
      opts.total = 0;
      opts.isLoading = true;
    }
  });
}
function openEditModalFromQuery (index) {
  if (didOpenFromQuery.value) return;
  const ruleIdRaw = route.query?.ruleId;
  const ruleGuid = route.query?.ruleGuid;

  if ((ruleIdRaw === undefined || ruleIdRaw === null || ruleIdRaw === '') &&
    (ruleGuid === undefined || ruleGuid === null || ruleGuid === '')) return;

  let rows = [];
  if (index === 0) {
    rows = processModule.value?.component?.options?.rows || [];
  } else if (index === 1) {
    rows = fileAccessModule.value?.component?.options?.rows || [];
  }
  else if (index === 2) {
    rows = registryModule.value?.component?.options?.rows || [];
  } else if (index === 3) {
    rows = codeLoadModule.value?.component?.options?.rows || [];
  } else if (index === 4) {
    rows = childLaunchModule.value?.component?.options?.rows || [];
  }
  if (!rows || rows.length === 0) return;

  let row = null;
  if (ruleIdRaw !== undefined && ruleIdRaw !== null && ruleIdRaw !== '') {
    const ruleId = Number(ruleIdRaw);
    if (!Number.isNaN(ruleId)) {
      row = rows.find(r => r && (r.id === ruleId));
    }
  }

  if (!row && ruleGuid) {
    const rg = String(ruleGuid).toLowerCase();
    row = rows.find(r => r && String(r.ruleGuid || '').toLowerCase() === rg);
  }

  if (!row) return;

  if (index === 0) {
    editFunction2(t('editRule'), ProcessEditForm, 'process', row);
  } else if (index === 1) {
    editFunction2(t('editRule'), FileAccessEditForm, 'fileAccess', row);
  } else if (index === 2) {
    editFunction2(t('editRule'), RegistryEditForm, 'registry', row);
  } else if (index === 3) {
    editFunction2(t('editRule'), CodeLoadEditForm, 'codeLoad', row);
  } else if (index === 4) {
    editFunction2(t('editRule'), ChildLaunchEditForm, 'childLaunch', row);
  }
  didOpenFromQuery.value = true;
}

watch(() => route.query.id, () => {
  resetAllTables();
  templatePolicy.value ? getAppGroupDetailTemplate(appGroupId) : getAppGroupDetail(appGroupId);
  fetchForTab(activeTab.value);
});

onBeforeUnmount(() => {
  resetAllTables();
});

function showEdit(title, formName, type, data = {}) {

  if (type === 'process') {
    linkedApp.value = true;
  } else {
    linkedApp.value = false;
  }
  canGoBack.value = false;

  const isAdd = title === t('addRule') && type === 'fileAccess';
  const isEdit = title === t('editRule') && data?.id === 0 && type === 'fileAccess';
  formModel.value = { ...data, __isAdd: isAdd, __isEdit: isEdit }

  formTitle.value = title;
  formFileName.value = formName;
  showPanel.value = true;
  formType.value = type;
}
const previousFormModel = ref(null);
function onChildEdit(payload) {
  if (!payload) return;
  linkedApp.value = false;
  canGoBack.value = true;
  if (payload.formType === 'fileTypePolicy') {
    previousFormModel.value = payload.previousFormModel
      ? { ...payload.previousFormModel }
      : { ...(formModel.value || {}) };
  }
  formTitle.value = payload.title || formTitle.value;
  formFileName.value = payload.formComponent || formFileName.value;
  formType.value = payload.formType || formType.value;
  formModel.value = payload.formModel ? { ...payload.formModel } : formModel.value;
  backTitle.value = payload.ruleId === 0 ? t('addRule') : t('editRule');
}
function onBack() {
  const source = previousFormModel.value || tableRowData.value || formModel.value || {};
  const original = JSON.parse(JSON.stringify(source));
  formTitle.value = backTitle.value;
  formFileName.value = ProcessEditForm;
  formType.value = 'process';
  formModel.value = { ...original };
  linkedApp.value = true;
  canGoBack.value = false;
}

const menu = ref()
const isMenuOpen = ref(false)

const restrictedNames = [
  'Restricted (TPL)',
  'Allow List',
  'Prohibited',
  'Standard Containment',
  'Private Containment',
  'Power Apps',
  'PowerApps',
]
const restrictedNamesLower = new Set(restrictedNames.map(n => String(n).toLowerCase()))

const isDeleteDisabled = computed(() => {
  const name = appGroupData.value?.name ? String(appGroupData.value.name).trim().toLowerCase() : ''
  if (name && restrictedNamesLower.has(name)) return true
  const typeId = Number(appGroupInfo.value?.appGroupType)
  if ([AppGroupTypes.PowerApps, AppGroupTypes.StandardContainment, AppGroupTypes.Private].includes(typeId)) return true
  return false
})

const isLinked = computed(() => {
  return store.state.general.inheritanceInfo?.isInherited
})
const isTemplateDefault = computed(() => {
  return store.state.general.isTemplateDefault
})

const isTemplatePolicyDefault = computed(() => {
  return store.state.general.isTemplatePolicyDefault
})
const items = computed(() => [
  ...(!templatePolicy.value
    ? [{ label: t('export'), command: () => doAction('export')}]
    : []),
  ...(showResetToDefaults.value
    ? [{ label: t('resetToDefault'), command: () => doAction('reset'), disabled: (!templatePolicy.value && isLinked.value ) || (templatePolicy.value && isTemplateDefault.value === false) || (isTemplatePolicyDefault.value === true)}]
    : []),
  { label: t('delete'), command: () => doAction('delete'), class: 'text-danger', disabled: isDeleteDisabled.value }
]);

const doAction = async (action) => {
  if (action === 'delete') {
    if (isDeleteDisabled.value) return
    deleteFunction(appGroupData.value)
  }
  else if (action === 'export') {
    exportModal.value?.open(appGroupData.value.id);
  }
  else if (action === 'reset') {
    const result = await Swal.fire({
      title: "Reset to Default",
      icon: "warning",
      text: "This action will restore the default role policies. All customizations will be permanently removed, the role policy connections will be re-established, and future updates will be applied automatically.",
      showCancelButton: true,
      confirmButtonText: "Reset to Default",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      didOpen: () => {
        const btn = Swal.getConfirmButton();
        if (btn) {
          btn.innerHTML = `<i class="pi pi-refresh" style="margin-right:8px"></i><span>Reset to Default</span>`;
        }
      },
    });
    if (result.isConfirmed) {
      resetToDefault()
    }
  }
}
async function resetToDefault() {
  const group = localStorage.getItem("agms_group");
  const groupId = group ? JSON.parse(group)?.mainid : null;
  try {
    if (templatePolicy.value) {
      await store.dispatch(
        GeneralActionTypes.TEMPLATE_RESET_TO_DEFAULT_APP_GROUP,
                {templateId: templateId.value, appGroupId: appGroupId.value}
      );
      getAppGroupDetailTemplate(appGroupId);
    } else {
      await store.dispatch(
        GeneralActionTypes.RESET_TO_DEFAULT_APP_GROUP,
                {appGroupId: appGroupId.value, groupId: groupId}
      );
      getAppGroupDetail(appGroupId);
      getInheritanceInfo();
    }
    Swal.fire("Success", "App Group has been reset to defaults.", "success");
  } catch (err) {
    showError(err);
  }
}

async function deleteFunction(data) {
  const result = await Swal.fire({
    title: "Are You Sure?",
    icon: "warning",
    text: "You are about to delete the selected item!",
    showCancelButton: true,
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
  });
  if (result.isConfirmed) {
    try {
      data.templateId = templateId.value;
      const response = templatePolicy.value
        ? await store.dispatch(GeneralActionTypes.DELETE_APPGROUP_TEMPLATE, data)
        : await store.dispatch(GeneralActionTypes.DELETE_APPGROUP, data.id);
      if (response.isSuccess) {
        Swal.fire("Deleted!", "App Group deleted successfully.", "success");
        router.push({
          path: templatePolicy.value
            ? '/administration/app-group-management-role'
            : '/administration/app-group-management',
        });

      } else {
        Swal.fire("Error", response.data?.message || "Delete failed.", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong while deleting.", "error");
    }
  }
};

function clearSearch() {
  searchQuery.value = '';
  statusFilter.value = [];

  const sortBy = (arr, accessor) => {
    if (!Array.isArray(arr)) return [];
    return [...arr].sort((a, b) => (accessor(a) || '').toString().localeCompare((accessor(b) || '').toString()));
  };

  if (processModule.value?.component?.options) {
    processModule.value.component.options.sortable.order = '';
    processModule.value.component.options.sortable.sort = '';
    const rows = processModule.value.component.options.rows || [];
    processModule.value.component.options.rows = sortBy(rows, (r) => r?.displayName || r?.fileName || '');
  }

  if (fileAccessModule.value?.component?.options) {
    fileAccessModule.value.component.options.sortable.order = '';
    fileAccessModule.value.component.options.sortable.sort = '';
    const rows = fileAccessModule.value.component.options.rows || [];
    fileAccessModule.value.component.options.rows = sortBy(rows, (r) => {
      const folder = r?.folderMapId ? getFolderNameById(r.folderMapId) : '';
      return `${folder} ${r?.fileName || ''}`.trim();
    });
  }

  if (registryModule.value?.component?.options) {
    registryModule.value.component.options.sortable.order = '';
    registryModule.value.component.options.sortable.sort = '';
    const rows = registryModule.value.component.options.rows || [];
    registryModule.value.component.options.rows = sortBy(rows, (r) => r?.registryKey || r?.registryValue || '');
  }

  if (codeLoadModule.value?.component?.options) {
    codeLoadModule.value.component.options.sortable.order = '';
    codeLoadModule.value.component.options.sortable.sort = '';
    const rows = codeLoadModule.value.component.options.rows || [];
    codeLoadModule.value.component.options.rows = sortBy(rows, (r) => {
      const folder = r?.folderMapId ? getFolderNameById(r.folderMapId) : '';
      return `${folder} ${r?.fileName || ''}`.trim();
    });
  }

  if (childLaunchModule.value?.component?.options) {
    childLaunchModule.value.component.options.sortable.order = '';
    childLaunchModule.value.component.options.sortable.sort = '';
    const rows = childLaunchModule.value.component.options.rows || [];
    childLaunchModule.value.component.options.rows = sortBy(rows, (r) => {
      const folder = r?.folderMapId ? getFolderNameById(r.folderMapId) : '';
      return `${folder} ${r?.fileName || ''}`.trim();
    });
  }
}

const importModal = ref(null);
const onImport = () => {
  if (importModal.value?.open) {
    importModal.value.open();
  } else {
    console.error("Modal ref not found!");
  }
};
function editFunction2(title, formName, formType, rowData) {
  tableRowData.value = rowData;
  showEdit(title, formName, formType, rowData)
}
async function copyFunction(rowData, type) {
  const copyData = { ...rowData, id: 0, enabled: false }
  if (type === 'process') {
    editFunction2(t('addRule'), ProcessEditForm, 'process', copyData)
  }
  else if (type === 'fileAccess') {
    editFunction2(t('addRule'), FileAccessEditForm, 'fileAccess', copyData)
  }
  else if (type === 'registry') {
    editFunction2(t('addRule'), RegistryEditForm, 'registry', copyData)
  }
  else if (type === 'codeLoad') {
    editFunction2(t('addRule'), CodeLoadEditForm, 'codeLoad', copyData)
  }
  else if (type === 'childLaunch') {
    editFunction2(t('addRule'), ChildLaunchEditForm, 'childLaunch', copyData)
  }
}
async function deleteAppGroup(rowData, type) {
  let apiMethod = null;
  if (type === 'childLaunch') {
    if(templatePolicy.value) {
      rowData.templateId = templateId.value;
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_CHILD_LAUNCH_TEMPLATE;
    } else {
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_CHILD_LAUNCH;
    }
  }
  else if (type === 'registry') {
    if(templatePolicy.value) {
      rowData.templateId = templateId.value;
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_REGISTRY_ACCESS_TEMPLATE;
    } else {
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_REGISTRY_ACCESS;
    }
  }
  else if (type === 'fileAccess') {
    if(templatePolicy.value) {
      rowData.templateId = templateId.value;
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_FILE_ACCESS_TEMPLATE;
    } else {
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_FILE_ACCESS;
    }
  }
  else if (type === 'codeLoad') {
    if(templatePolicy.value) {
      rowData.templateId = templateId.value;
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_CODE_LOAD_TEMPLATE;
    } else {
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_CODE_LOAD;
    }
  }
  else if (type === 'process') {
    if(templatePolicy.value) {
      rowData.templateId = templateId.value;
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_PROCESS_TEMPLATE;
    } else {
      apiMethod = GeneralActionTypes.DELETE_APPGROUP_PROCESS;
    }
  }

  const result = await Swal.fire({
    title: "Are You Sure?",
    icon: "warning",
    text: "You are about to delete the selected item!",
    showCancelButton: true,
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
  });
  if (result.isConfirmed) {
    try {
      const responseApi = await store.dispatch(apiMethod, templatePolicy.value ? rowData : rowData.id);
      if (responseApi.isSuccess) {
        if(!templatePolicy.value){
          getInheritanceInfo();
        }
        Swal.fire("Deleted!", "Rule deleted successfully.", "success");
        if (type === 'childLaunch') {
          if(templatePolicy.value){
            getChildLaunchListTemplate();
            getAppGroupDetailTemplate(appGroupId);
          }else{
            getChildLaunchList();
            getAppGroupDetail(appGroupId);
          }
        }
        else if (type === 'registry') {
          if(templatePolicy.value){
            getRegistryListTemplate();
            getAppGroupDetailTemplate(appGroupId);
          }else{
            getRegistryList();
            getAppGroupDetail(appGroupId);
          }
        }
        else if (type === 'fileAccess') {
          if(templatePolicy.value){
            getFileAccessListTemplate();
            getAppGroupDetailTemplate(appGroupId);
          }else{
            getFileAccessList();
            getAppGroupDetail(appGroupId);
          }
        }
        else if (type === 'codeLoad') {
          if(templatePolicy.value){
            getCodeLoadListTemplate();
            getAppGroupDetailTemplate(appGroupId);
          }else{
            getCodeLoadList();
            getAppGroupDetail(appGroupId);
          }
        }
        else if (type === 'process') {
          if(templatePolicy.value){
            getProcessListTemplate();
            getAppGroupDetailTemplate(appGroupId);
          }else{
            getProcessList();
            getAppGroupDetail(appGroupId);
          }
        }
      } else {
        Swal.fire("Error", responseApi.data?.message || "Delete failed.", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong while deleting.", "error");
    }
  }
};

const isLongDescription = computed(() => (appGroupData.value?.description || '').length > 250)
const truncatedDescription = computed(() => {
  const txt = (appGroupData.value?.description || '')
  return txt.length > 250 ? txt.slice(0, 250) + '…' : txt
})
const showDescPanel = ref(false)

const discoveryOptions = computed(() => store.state.general.enums['DiscoveryMode'] || []);
const realDiscoveryOptions = computed(() => discoveryOptions.value.filter((opt) => opt.label !== 'Enable All'));
function computeDiscoveryLabels(value) {
  if (!value) return [];
  let total = 0;
  if (typeof value === 'string') {
    total = value
      .split(',')
      .map((v) => parseInt(v.trim(), 10))
      .reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
  } else {
    total = Number(value) || 0;
  }
  return realDiscoveryOptions.value
    .filter((opt) => {
      const optVal = opt.value;
      if (typeof optVal === 'string' && optVal.includes('|')) {
        const keys = optVal.split('|').map((k) => parseInt(k, 10)).filter((n) => !isNaN(n));
        return keys.every((k) => (total & k) === k);
      }
      const n = Number(optVal);
      return !isNaN(n) && (total & n) !== 0;
    })
    .map((opt) => opt.label);
}
const discoverySelectedLabels = computed(() => computeDiscoveryLabels(appGroupData.value?.subsystemsInDiscoveryMode));

watch(() => route.query.id, (newId) => {
  selectedAppGroupId.value = newId ? Number(newId) : null;
});

function onSelectAppGroup(e) {
  searchText.value = '';
  const newId = e?.value ?? selectedAppGroupId.value;
  if (!newId) return;
  if (String(newId) === String(appGroupId.value)) return;
  router.replace({ query: { ...route.query, id: newId } });
}
</script>

<style>
.btn-primary {
  background-color: #0b4c8c;
  border-color: #0b4c8c;
}

.btn-primary .pi {
  margin-left: 0.5rem;
}

.btn-light {
  background-color: #94A4B9;
  color: #0b4c8c;
}

.custom-tabs .p-tabview-nav {
  border-bottom: none !important;
  justify-content: start;
  gap: 5rem;
  background-color: transparent !important;
  padding-left: 1rem;
}

.custom-tabs .p-tabview-nav li .p-tabview-nav-link {
  color: #898C90 !important;
  font-weight: bold;
  border: none;
  border-radius: 0;
  background: transparent;
  font-size: 1.1rem;
  padding: 0.75rem 0;
  transition: color 0.2s ease;
}

.custom-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #0055A6 !important;
  border-bottom: 2px solid #0055A6;
  background: transparent;
}

.custom-tabs .p-tabview-nav li .p-tabview-nav-link:hover {
  color: #0b4c8c;
  background: transparent;
}

.custom-icon-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #2c5f89;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0;
  font-size: 0.8rem;
}

.custom-icon-button:hover {
  opacity: 0.8;
  cursor: pointer;
}

.icon-circle {
  background-color: #2c5f89;
  color: white;
  border-radius: 50%;
  padding: 8px;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-edit-icon {
  width: 20px;
  height: 20px;
}

.search-wrapper {
  position: relative;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.p-tabview .p-tabview-panels {
  background-color: transparent;
}

.table-border-div {
  border-top: 1px solid #D2D9E2;
  border-left: 1px solid #D2D9E2;
  border-right: 1px solid #D2D9E2;
  padding-top: 30px;
}

.edit-btn-div {
  border-right: 1px solid #D2D9E2;
  padding: 0 30px;
}

.text-muted {

  padding-bottom: 5px;
  color: #01172F !important;
  font-size: 0.8em;
}

.top-div {
  background-color: #fff;
  margin-left: -25px;
  margin-right: -15px;
  margin-top: -23px;
  margin-bottom: 40px;
  padding: 40px;
  filter: drop-shadow(0 2px 26px rgba(0, 0, 0, 0.12));
}

#ag-table .table td {
  border: 0px;
  border-top: 1px solid #D2D9E2 !important;
}
.app-group-detail #ag-table:has(thead th.checkbox-th) thead th.checkbox-th + th,
.app-group-detail #ag-table:has(tbody td .row-checkbox) tbody td:has(.row-checkbox) + td {
  border-left: 0 !important;
}

.label-text {
  color: #3C73AA;
}

.actions-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background-color: #0C4F93;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  min-width: 12.5rem;
}

.actions-btn .label {
  font-size: 0.95rem;
}

.actions-btn .divider {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.6);
  margin-left: auto;
}

.actions-btn .chevron {
  color: #ffffff;
  font-size: 0.9rem;
}

.actions-btn:hover {
  opacity: 0.95;
}

.p-menu {
  border: 1px solid #D2D9E2 !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.p-menu .p-menuitem-link {
  padding: 0.75rem 1rem !important;
  color: #0B1736 !important;
  font-weight: 600;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-menu .text-danger {
  color: #C62828 !important;
}

.desc-hover-container {
  padding-left: 0;
  position: relative;
  border-bottom: 1px solid #D2D9E2;
}

.desc-hover-trigger {
  position: relative;
  display: inline-block;
}

.desc-hover-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #fff;
  color: #01172F;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  padding: 8px 10px;
  z-index: 1050;
  max-width: 720px;
  max-height: 240px;
  overflow: auto;
  white-space: normal;
  line-height: 1.3;
}

.btn-div {
  margin-left: 50px;
}

.tab-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 9px;
}

.tab-header .pi {
  color: #94A4B9;
  font-size: 0.95rem;
}

.tab-header .pi:hover {
  color: #0055A6;
}
.div-wrapper .dataTables_wrapper thead th > div {
  color: #5D5F62 !important;
  font-weight: 700 !important;
}
.div-wrapper .dataTables_wrapper thead th > div span,
.div-wrapper .dataTables_wrapper thead th > div .ag-tooltip {
  color: inherit !important;
  font-weight: inherit !important;
}

.appgroup-change-dropdown.p-dropdown {
  border: 1px solid #BDD0E0 !important;
  background-color: #EEF7FF!important;
  border-radius: 2px;
}
.appgroup-change-dropdown.p-dropdown .p-dropdown-label {
  padding: 0.05rem 0.4rem 0.05rem 0.2rem;
  font-size: 10px;
  color: #4B7CB3;
  width: 100%;
  font-weight: bold;
}
.my-dropdown-panel .p-dropdown-item {
  padding: 0.3rem 1.25rem !important;
}
.custom-search {
  position: relative;
  padding: 10px;
}

.custom-search-input {
  width: 100%;
  border-radius: 2px;
  border: 1px solid #cbd5e1;
  padding: 4px 5px 4px 5px;
  outline: none;
  font-size: 11px;
}

.search-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}

.custom-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  font-style: 14px;
}
.custom-item .label {
  color:#5D5F62 ;
  font-size: 12px;
}

.radio {
  width: 14px;
  height: 14px;
  border: 1px solid #8a94a0;
  border-radius: 50%;
  position: relative;
}

.radio.selected::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #2563eb;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.p-dropdown-item:hover {
  background-color: #f1f5f9 !important;
}
.custom-separator {
  height: 1px;
  background-color: #e5e7eb;
  margin: 0 16px;
}
.appgroup-change-dropdown .p-dropdown-trigger {
  justify-content: start;
  width: auto;
  padding-right: 0.3rem;
}
.custom-arrow {
  display: inline-block;
  width: 0;
  height: 0;

  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #4B7CB3
}
.custom-arrow.open {
  transform: rotate(180deg);
}
.p-dropdown-panel {
  transform: translateY(8px);
}
.p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none !important;
}
.actions-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background-color: #0C4F93;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  min-width: 12.5rem;
}

.actions-btn .label {
  font-size: 0.95rem;
}

.actions-btn .divider {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.6);
  margin-left: auto;
}

.actions-btn .chevron {
  color: #ffffff;
  font-size: 0.9rem;
}

.actions-btn:hover {
  opacity: 0.95;
}

.p-menu {
  border: 1px solid #D2D9E2 !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.p-menu .p-menuitem-link {
  padding: 0.75rem 1rem !important;
  color: #0B1736 !important;
  font-weight: 600;
}

.p-menu .p-menuitem-link .p-menuitem-icon {
  margin-right: 0.5rem;
}

.p-menu .text-danger {
  color: #C62828 !important;
}

.desc-hover-container {
  padding-left: 0;
  position: relative;
  border-bottom: 1px solid #D2D9E2;
}

.desc-hover-trigger {
  position: relative;
  display: inline-block;
}

.desc-hover-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #fff;
  color: #01172F;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  padding: 8px 10px;
  z-index: 1050;
  max-width: 720px;
  max-height: 240px;
  overflow: auto;
  white-space: normal;
  line-height: 1.3;
}

.btn-div {
  margin-left: 50px;
}

.tab-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 9px;
}

.tab-header .pi {
  color: #94A4B9;
  font-size: 0.95rem;
}

.tab-header .pi:hover {
  color: #0055A6;
}
.ag-card_body {
    border: none !important;
}
.p-dropdown .p-dropdown-clear-icon {
    width: 0.7rem;
    margin-right: -0.5rem;
}
</style>
